/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

export type CollectionData = typeof CollectionData[keyof typeof CollectionData];


export const CollectionData = {
  static: 'static',
  dynamic: 'dynamic',
} as const;
